import { useEffectOnce } from 'react-use';
import { useDispatch } from 'react-redux';
import type { Dispatch } from 'redux';

import { HeaderInfo } from 'CorePackage/HeaderInfoModule/components/HeaderInfo';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { TablePage } from 'CorePackage/TableModule/components/TablePage';

import { AnalyticsPanel } from './AnalyticsPanel';
import { AnalyticsTable } from './AnalyticsTable';
import { analyticsInit } from '../actions/analyticsActions';

export const Analytics = () => {
  const dispatch = useDispatch<Dispatch<RootActions>>();

  useEffectOnce(() => {
    dispatch(analyticsInit());
  });

  return (
    <>
      <HeaderInfo />
      <TablePage>
        <AnalyticsPanel />
        <AnalyticsTable />
      </TablePage>
    </>
  );
};
